import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { CanDeactivate } from '@angular/router';

export interface formsEditGuard {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean
}

@Injectable()

export class formsEditGuardService implements CanDeactivate<formsEditGuard> {
    canDeactivate(component: formsEditGuard ):  Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
        
    }
}

